import { createSocketClient } from '@/shared/lib/socket/SharedWorkerClient';

const BINANCE_WS_URL = 'wss://stream.binance.com:9443/ws';

/**
 * Binance WebSocket 구독 메시지 생성 (fallback용).
 * Binance 형식: { method: 'SUBSCRIBE', params: ['btcusdt@ticker'], id: 1 }
 */
let binanceFallbackId = 0;
const buildBinanceSubscribeMessage = (type: string, codes: string[]) => ({
  method: 'SUBSCRIBE',
  params: codes.map(code => `${code}@${type}`),
  id: ++binanceFallbackId,
});

export const binanceSocketManager = createSocketClient({
  exchange: 'binance',
  url: BINANCE_WS_URL,
  buildSubscribeMessage: buildBinanceSubscribeMessage,
  subscribeFormat: 'binance',
  // 🔴 TRAD-3086 — 바이낸스는 앱레벨 PING/pong 계약이 없다. shared-worker.ts 의 좀비 감시
  // (TRAD-3045)가 보내는 리터럴 텍스트 'PING' 을 실제 바이낸스 서버에 직접 보내 실측한
  // 결과 `{"error":{"code":3,"msg":"Invalid JSON: expected value at line 1 column 1"}}` 로
  // 응답한 뒤 `CLOSE code=1008 reason="Invalid request"` 로 연결을 끊는다 — 우리가 보낸 PING
  // 이 스스로 연결을 죽이는 자해였다. pingInterval<=0 이면 shared-worker.ts 의 startPing()
  // 이 아예 발동하지 않는다(기존 가드 `if (state.config.pingInterval <= 0) return;` 재사용).
  // 이 값은 이미 kimchiPremiumSocketClient(STOMP, 자체 하트비트 사용)에서 쓰던 것과 같은
  // 패턴이다 — 신규 워크어라운드가 아니라 이 코드베이스에 이미 있는 관용구를 재사용한 것.
  // 🔴 이걸로 잃는 것 — 바이낸스에 대해서는 pong 기반 좀비 연결 감시(45초 워치독)가 아예
  // 없어진다. 원래도 없었다(이 티켓 조사 전에도 isPongFrame 이 바이낸스 pong 을 인식한
  // 적이 없다) — 신규 손실이 아니라 이미 있던 커버리지 공백을 문서화하는 것뿐이다. 서버가
  // close 프레임 없이 조용히 죽는 시나리오(TRAD-웹소켓끊김 이 대응하던 것과 같은 종류)가
  // 바이낸스에서 발생하면 이 감시망이 못 잡는다 — 필요해지면 별도 티켓으로 바이낸스 전용
  // liveness 신호(예: 정상 ticker 프레임 수신 자체를 pong 대용으로 쓰는 방식)를 설계해야 한다.
  pingInterval: 0,
});
